import Vue from "vue";
import VueTopProgress from "vue-top-progress";
Vue.use(VueTopProgress);
